export { default } from './DataPrivacy';
